<script>
import BaseCard from "../BaseCard";
import { mapGetters } from "vuex";

export default {
  name: "MainPropertiesCard",
  extends: BaseCard,
  props: ["vz"],
  data: function() {
    return {
      header: "Algemene eigenschappen",
      disabled: !this.hasPermission("update voorziening"),
      values: {
        voorziening_type: this.vz.voorziening_type.id,
        ondergrond: this.vz.ondergrond.id,
        breedte: this.vz.breedte,
        lengte: this.vz.lengte,
        hoogte: this.vz.hoogte,
        indoor: this.vz.indoor,
        zonnepanelen_aanwezig: this.vz.zonnepanelen_aanwezig
      }
    };
  },
  computed: {
    ...mapGetters({
      options_services: "services_flattened",
      options_substrates: "substrates_flattened"
    }),
    schema: function() {
      return [
        {
          type: "select",
          name: "voorziening_type",
          label: "Type voorziening",
          placeholder: "Onbekend",
          options: this.options_services.map(this.shorten_label),
          disabled: this.disabled,
          "input-class": this.disabled ? "disabled" : "editMode"
        },
        {
          type: "select",
          name: "ondergrond",
          label: "Ondergrond",
          placeholder: "Onbekend",
          options: this.options_substrates.map(this.shorten_label),
          disabled: this.disabled,
          "input-class": this.disabled ? "disabled" : "editMode"
        },
        {
          type: "text",
          name: "lengte",
          label: "Lengte",
          placeholder: "Onbekend",
          disabled: this.disabled,
          validation: "number",
          "validation-messages": {
            number: "Lengte moet een getal zijn"
          },
          "input-class": this.disabled ? "disabled" : "editMode"
        },
        {
          type: "text",
          name: "breedte",
          label: "Breedte",
          placeholder: "Onbekend",
          disabled: this.disabled,
          validation: "number",
          "validation-messages": {
            number: "Breedte moet een getal zijn"
          },
          "input-class": this.disabled ? "disabled" : "editMode"
        },
        {
          type: "text",
          name: "hoogte",
          label: "Hoogte",
          placeholder: "Onbekend",
          disabled: this.disabled,
          validation: "number",
          "validation-messages": {
            number: "Hoogte moet een getal zijn"
          },
          "input-class": this.disabled ? "disabled" : "editMode"
        },
        {
          type: "checkbox",
          name: "indoor",
          label: "Indoor",
          disabled: this.disabled,
          "label-position": "before"
        },
        {
          type: "checkbox",
          name: "zonnepanelen_aanwezig",
          label: "Zonnepanelen",
          disabled: this.disabled,
          "label-position": "before"
        },

        {
          type: "submit",
          "input-class": ["btn", "btn-blue", this.disabled ? "disabled" : ""],
          label: "Opslaan"
        }
      ];
    }
  },
  methods: {
    shorten_label: item => ({
      // TODO: this is a temp bug fix for size of field
      // We may be able to fix this with CSS
      // This impacts position of mobile nav
      ...item,
      label: item.label.slice(0, 20)
    }),
    submitHandler: async function(data) {
      const updatedVoorziening = {
        lengte: parseInt(data.lengte),
        breedte: parseInt(data.breedte),
        hoogte: parseInt(data.hoogte),
        indoor: data.indoor,
        ondergrond: { id: data.ondergrond },
        zonnepanelen_aanwezig: data.zonnepanelen_aanwezig,
        voorziening_type: { id: data.voorziening_type }
      };
      const [ok, msg] = await this.$store.dispatch("updateVoorziening", {
        id: this.vz.id,
        properties: updatedVoorziening
      });
      this.parseResponse(ok, msg);
    }
  }
};
</script>
